import {ChangeDetectionStrategy, Component} from '@angular/core';
import {AuthService} from "../_services/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {FeedbackComponent} from "../shared/feedback/feedback.component";
import {User} from "../_types/user";

@Component({
    selector: 'app-noboxes',
    templateUrl: './noboxes.component.html',
    styleUrl: './noboxes.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NoboxesComponent {
    user!: User;
    contactEmail: string | undefined;

    constructor(private authService: AuthService,
                public dialog: MatDialog) {
        this.dialog.closeAll();
        this.authService.getUser().subscribe({
            next: r => {
                this.user = r;
            }
        })
        this.authService.getDynamicSettings().then((r): void => {
            this.contactEmail = r.contact_email;
        });
    }

    logout(): void {
        this.authService.logout();
    }

    feedback(): void {
        if (this.dialog.openDialogs.length == 0) {
            this.dialog.open(FeedbackComponent);
        }
    }

}

